module.exports = __webpack_public_path__ + "static/media/alien.abda26e2.png";